import StyleTweeners from '../style-tweeners'
import { EPSILON } from 'chart-constants'

/*
 * Used for transforming series from area <-> stacked areas
 */
class AreaStackTransformer {

  constructor (options) {
    this.styleTweeners = new StyleTweeners(options.styles)
    this.series = options.series
    this.exitingSeries = options.exitingSeries
  }

  /*
   * Repositions nodes using a fade. This is used when a single serie is turned
   * into a new stack, or a stack of areas is tranformed to a single area.
   */
  transform (serie, entering, selection, merged, exiting) {
    let fadeOut = this.exitingSeries.filter(f => f.id === serie.id).size()

    if (fadeOut) {
      merged.tween('fade-out', this.styleTweeners.fadeOut(merged, true, 1))
    }

    let fadeIn = this.series.filter(f => f.id === serie.id).size()

    if (fadeIn && entering.size()) {
      entering.selectAll('path.line').style('opacity', EPSILON) // Don't show the line path immediately

      merged.tween('fade-in', this.styleTweeners.fadeIn(merged, true, 0))
    }
  }

}

export default AreaStackTransformer
